/**
 * The external dependencies.
 */
import {call, put} from 'redux-saga/effects';
/**
 * The internal dependencies.
 */
import {endRequest, endRequestWithError, startRequest} from '../store/requests/actions';
import {callRoute} from '../common/api';

export default function* (options) {
    const {
        endpoint,
        params = [],
        requestAction,
        receiveAction,
        receiveActionParams = [],
        successMessage = ''
    } = options;

    try {
        // Start tracking of the network request.
        yield put(startRequest(requestAction.type));

        const {data} = yield call(callRoute, [endpoint, ...params]);

        // Update the store with the results.
        yield put(receiveAction(data, ...receiveActionParams));

        // Stop tracking of the network request.
        yield put(endRequest(requestAction.type, successMessage));
    } catch (e) {
        // Stop tracking of the network request and store the error.
        yield put(endRequestWithError(requestAction.type, e));
    }
}



// WEBPACK FOOTER //
// ./src/common/request.js